var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFinance(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1768818069266,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 21098,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M673.597786 490.519051H329.678367a33.634054 33.634054 0 0 1 0-67.268109h343.919419a33.634054 33.634054 0 0 1 0 67.268109zM673.597786 643.912762H329.678367a33.634054 33.634054 0 0 1 0-67.268109h343.919419a33.634054 33.634054 0 0 1 0 67.268109z",
    fill: "",
    "p-id": 21099
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M510.29324 817.419637a33.634054 33.634054 0 0 1-33.634055-33.634054V456.884996a33.634054 33.634054 0 0 1 67.268109 0v326.900587a33.634054 33.634054 0 0 1-33.634054 33.634054z",
    fill: "",
    "p-id": 21100
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M497.84864 470.719804a33.634054 33.634054 0 0 1-23.790488-9.843567l-165.681352-165.771043a33.634054 33.634054 0 1 1 47.558553-47.558553l165.771043 165.771043a33.634054 33.634054 0 0 1-23.857756 57.40212z",
    fill: "",
    "p-id": 21101
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M522.670572 473.119033a33.634054 33.634054 0 0 1-23.790488-57.424542l165.771043-165.771044a33.634054 33.634054 0 1 1 47.558553 47.558554L546.438637 463.253044a33.634054 33.634054 0 0 1-23.768065 9.865989z",
    fill: "",
    "p-id": 21102
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M46.90566 452.198651A35.876325 35.876325 0 0 1 11.657171 409.460979C57.780671 172.206359 266.894799 0 509.059991 0a506.910046 506.910046 0 0 1 496.461067 404.662521 35.876325 35.876325 0 1 1-70.295174 14.395375A435.157397 435.157397 0 0 0 509.059991 71.75265C301.24638 71.75265 121.685374 219.540685 82.064458 423.183673a35.876325 35.876325 0 0 1-35.158798 29.014978z",
    fill: "",
    "p-id": 21103
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M47.802568 454.463344A35.876325 35.876325 0 0 1 33.698688 385.670491l118.122799-50.899535a35.883052 35.883052 0 1 1 28.36472 65.922746l-118.212491 50.854691a35.876325 35.876325 0 0 1-14.171148 2.914951zM514.889894 1024A506.910046 506.910046 0 0 1 18.428827 619.337479a35.876325 35.876325 0 0 1 70.295174-14.395375 435.157397 435.157397 0 0 0 426.165893 347.305246c207.813611 0 387.374617-147.788035 426.97311-351.431023a35.876325 35.876325 0 1 1 70.42971 13.700271c-46.1235 237.277043-255.327319 409.483402-497.40282 409.483402z",
    fill: "",
    "p-id": 21104
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M857.979672 692.143996a35.876325 35.876325 0 0 1-14.193571-68.837698l118.212491-50.854691a35.876325 35.876325 0 1 1 28.364719 65.900324l-118.21249 50.854691a35.876325 35.876325 0 0 1-14.171149 2.937374z",
    fill: "",
    "p-id": 21105
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinance);
export default __webpack_public_path__ + "static/media/finance.33078d5f184d7300ebf28a2a4ffa3873.svg";
export { ForwardRef as ReactComponent };